import { ThemeVariant } from 'shared/assets/theme/themeTypes';
import { makeAutoObservable } from 'mobx';
import { RootStore } from 'app/store/rootStore';
import { constructTheme } from 'shared/lib/utils/constructTheme';

export class UiStore {
  public rootStore: RootStore;

  public currentThemeVariant = constructTheme(ThemeVariant.LIGHT);
  public lastPathnameBeforeSearch = '/';
  public lastSearchParamsBeforeSearch = '';

  constructor({ rootStore }: { rootStore: RootStore }) {
    this.rootStore = rootStore;
    makeAutoObservable(this);
  }

  public setCurrentThemeVariant(variant: ThemeVariant) {
    this.currentThemeVariant = constructTheme(variant);
  }
}
